module.exports = __webpack_public_path__ + "img/pic01.8ed62a21.png";